import React, { useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";

// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";
import {
    NotificacionToastDeCreacion,
    // NotificacionToastDeError,
} from "../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionesToast";

import * as TipoDeError from "../../isp._comun/services/Errores";

import PlanReducer from "../reductores/PlanReducer";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";
import CargaDePlanConsultado from "../reductores/acciones/dispatch/CargaDePlanConsultado";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

import DialogoPlanLayout from "./layouts/DialogoPlanLayout";
// import { TipoDePlan } from "../../reductores/Constantes";

import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";
import DataDeRespuestas_De_Plan from "../../isp.žapi.planes/DataEstaticaDeRespuestas.json";
import ServiceRegistroDePlan from "../../isp.žapi.planes/ServiceRegistroDePlan";
import ServiceDeActualizacionDePlan from "../../isp.žapi.planes/ServiceDeActualizacionDePlan";
import ServiceQueryUnPlan from "../../isp.žapi.planes/ServiceQueryUnPlan";

const DialogoPlan = ({ ventana }) => {
    const { handleErroresExtraEnPrincipal, notificar } = useContext(GlobalContext);

    const [estadoDCF, dispatchDCF] = useReducer(PlanReducer, ventana.estadoComp);
    ventana.estadoComp = estadoDCF;

    const ServiceApiRegistrarPlan = new ServiceRegistroDePlan();
    const registrarPlanCommand = new ComandoAPI(ServiceApiRegistrarPlan);

    registrarPlanCommand.ejecutar = async () => {
        const plan = {
            nombre: estadoDCF.domain.screen.nombre,
            descripcion: estadoDCF.domain.screen.descripcion,
            precio: estadoDCF.domain.screen.precio,
            moneda: estadoDCF.domain.screen.moneda,
            udm: estadoDCF.domain.screen.udm,
            anchoBanda: estadoDCF.domain.screen.anchoBanda,
            unidAnchoBanda: estadoDCF.domain.screen.unidAnchoBanda,
        };

        try {
            const dataRegistradaDePlan = await ServiceApiRegistrarPlan.ejecutar(plan);
            dispatchDCF(new Action.CargaDePlanRegistrado(dataRegistradaDePlan));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_De_Plan.CreacionClienteAFacturar.titulo,
                    DataDeRespuestas_De_Plan.CreacionClienteAFacturar.mensaje,
                    dataRegistradaDePlan.idPlan
                )
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearPlan(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };

    const ServiceApiActualizarPlan = new ServiceDeActualizacionDePlan();
    const actualizarPlanCommand = new ComandoAPI(ServiceApiActualizarPlan);

    actualizarPlanCommand.ejecutar = async () => {
        const planPorActualizar = {
            id: estadoDCF.domain.screen.idPlan,
            data: estadoDCF.domain.update,
        };

        try {
            // const servicio = new ServicioDeActualizacionDePlan();
            // actualizarPlanCommand.servicio = servicio;
            // const dataDeClienteActualizado =
            await ServiceApiActualizarPlan.ejecutar(planPorActualizar);
            dispatchDCF(new Action.CargaDePlanActualizado());
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarPlan(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
            }
            handleErroresExtraEnPrincipal(error);
        }
    };

    const ServicioApiQueryUnPlan = new ServiceQueryUnPlan();
    const buscarUnSoloPlanCommand = new ComandoAPI(ServicioApiQueryUnPlan);

    buscarUnSoloPlanCommand.ejecutar = async (idPlan) => {
        try {
            // const servicio = new ServicioDeQueryDeUnPlan();
            // buscarUnSoloPlanCommand.servicio = servicio;
            const respuestaQuery = await ServicioApiQueryUnPlan.ejecutar(idPlan);
            dispatchDCF(new CargaDePlanConsultado(respuestaQuery.plan));
            // ventana.ventanaCargando.dispatch(new CargaDeClienteConsultado(respuestaQuery.cliente));
            // dispatchQ(new CargaDeClientesBuscados(respuestaQuery.clientes));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarCliente(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    return (
        <DialogoPlanLayout
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            registrarPlanCommand={registrarPlanCommand}
            actualizarPlanCommand={actualizarPlanCommand}
            buscarUnSoloPlanCommand={buscarUnSoloPlanCommand}
        />
    );
};

export default DialogoPlan;
